
import { createActionTypeModel } from "../../../../store/global/action-model";
// Type Container for TracksCatalog Action/Mutation Types. Use it in   tracks/actions.js, tracks/mutations.js and the Vuex Host Component 
export const TracksCatalogData = createActionTypeModel('TracksCatalogData');
export const TrackList = createActionTypeModel('TrackList');
export const TrackDetails = createActionTypeModel('TrackDetails');
export const TrackCredits = createActionTypeModel('TrackCredits');
export const TrackAdditionalInfo = createActionTypeModel('TrackAdditionalInfo');
export const TrackGenre = createActionTypeModel('TrackGenre');
export const TrackExternalIds = createActionTypeModel('TrackExternalIds');
export const TrackManualMatches = createActionTypeModel('TrackManualMatches');
export const TrackRelatedProducts = createActionTypeModel('TrackRelatedProducts');
export const MetaData = createActionTypeModel('MetaData');

export const ADVANCED_SEARCH_CONFIG = 'ADVANCED_SEARCH_CONFIG';
export const SET_MAIN_PRODUCT = 'SET_MAIN_PRODUCT';

export const SET_TRACK_PRODUCT_FILES = 'SET_TRACK_PRODUCT_FILES';
